import {
  Button,
  PageHeader,
  Segmented,
  Pagination,
  Divider,
  Empty,
  Spin,
} from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { SurveyResult } from "./survey-result";
import styled from "styled-components";
import { useContext, useState, useRef } from "react";
import { ReviewContext } from "../../lib/review-context";
import { sortBy } from "lodash";

const PAGE_SIZE = 3;

const PlacementMedal = ({ id, topReviews }) => {
  let medal = null;

  console.log(id, topReviews);

  if (id === topReviews[0]?.id) {
    medal = "🥇";
  }
  if (id === topReviews[1]?.id) {
    medal = "🥈";
  }
  if (id === topReviews[2]?.id) {
    medal = "🥉";
  }

  return medal ? <div style={{ fontSize: 24 }}>{medal}</div> : null;
};

const YourReview = ({ loading, submittedReview, topReviews }) => {
  const navigate = useNavigate();

  // Continue to show review if one exists, even when loading
  if (!submittedReview && loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Spin />
      </div>
    );
  }

  if (submittedReview) {
    return (
      <SurveyResult
        review={submittedReview}
        placement={
          <PlacementMedal id={submittedReview.id} topReviews={topReviews} />
        }
      />
    );
  }

  // No review submitted
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      <Button
        key="home-button"
        type="default"
        block
        onClick={() => navigate("../")}
        size="small"
        style={{ width: "100px" }}
      >
        Take Survey
      </Button>
    </div>
  );
};

// https://firebase.google.com/docs/firestore/quickstart#web-version-9_1/
export const Results = () => {
  const otherReviewsRef = useRef();

  const { submittedReview, refreshReviews, allReviews, loading } =
    useContext(ReviewContext);

  const [segment, setSegment] = useState("Top");
  const [page, setPage] = useState(1);

  const recentReviews = sortBy(allReviews, (r) => -r.createdAt).slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  const topReviews = sortBy(allReviews, (r) => -r.likes).slice(0, 3);

  console.log(topReviews);

  const segmentedList = segment === "Top" ? topReviews : recentReviews;

  return (
    <Wrapper>
      <PageHeader title="Your Review" style={{ padding: 0 }} />

      <YourReview
        submittedReview={submittedReview}
        topReviews={topReviews}
        loading={loading}
      />

      <Divider />
      <PageHeader
        title={`Other Reviews (${allReviews.length || 0})`}
        extra={[
          <Button
            key="refresh-button1"
            type="default"
            onClick={() => refreshReviews()}
            size="small"
          >
            <SyncOutlined spin={loading} />
          </Button>,
        ]}
        style={{ padding: 0 }}
      />

      <Segmented
        block
        options={["Top", "Recent"]}
        onChange={(v) => {
          setSegment(v);
        }}
        style={{ margin: "12px 0" }}
      />

      <div ref={otherReviewsRef}>
        {segmentedList.map((r, i) => (
          <SurveyResult
            key={`survey-results-${i}`}
            review={r}
            placement={<PlacementMedal id={r.id} topReviews={topReviews} />}
          />
        ))}
      </div>

      {segment === "Recent" && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Pagination
            simple
            current={page}
            total={allReviews.length}
            defaultPageSize={PAGE_SIZE}
            onChange={(v) => {
              setPage(v);
              otherReviewsRef.current.scrollIntoView();
            }}
          />
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;
